// NumberLineAxis.js
// Współdzielona oś liczbowa dla zadań E8 (np. 2025 MAJ zad. 12, 2025 CZE zad. 19).
// Jednolity krój: kolory z motywu (currentColor), podpisy renderowane przez KaTeX
// (SvgMathLabel), te same proporcje kresek i strzałki.
//
// Indeksy są liczone w działkach (0 .. divisions). Etykiety i znaczniki podaje się
// na zadanych indeksach (mogą być ułamkowe, np. 2.5).

import React from "react";
import SvgMathLabel from "./SvgMathLabel";

export default function NumberLineAxis({
  divisions,
  width = 440,
  height = 84,
  topLabels = [], // [{ index, math }] – nazwy punktów nad osią
  bottomLabels = [], // [{ index, math }] – wartości pod osią
  markers = [], // [{ index }] – wypełnione kropki na osi
  ariaLabel = "Oś liczbowa",
}) {
  const leftX = 24;
  const rightX = width - 24;
  const segmentStartX = 54;
  const segmentEndX = rightX - 42;
  const axisY = Math.round(height * 0.62);
  const arrow = 10;
  const tickLength = 6;
  const color = "currentColor";

  const pointX = (index) => segmentStartX + (index / divisions) * (segmentEndX - segmentStartX);

  return (
    <svg
      width="min(100%, 460px)"
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      role="img"
      aria-label={ariaLabel}
      style={{ display: "block", overflow: "visible" }}
    >
      <line
        x1={leftX}
        y1={axisY}
        x2={rightX}
        y2={axisY}
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d={`M ${rightX - arrow} ${axisY - arrow / 2} L ${rightX} ${axisY} L ${rightX - arrow} ${axisY + arrow / 2} Z`}
        fill={color}
      />
      {Array.from({ length: divisions + 1 }, (_, index) => (
        <line
          key={`tick-${index}`}
          x1={pointX(index)}
          y1={axisY - tickLength - 1}
          x2={pointX(index)}
          y2={axisY + tickLength + 1}
          stroke={color}
          strokeWidth="1.8"
          strokeLinecap="round"
        />
      ))}
      {markers.map((marker) => (
        <circle key={`marker-${marker.index}`} cx={pointX(marker.index)} cy={axisY} r="3.4" fill={color} />
      ))}
      {topLabels.map((label) => (
        <SvgMathLabel key={`top-${label.index}`} x={pointX(label.index)} y={axisY - 19} math={label.math} fontSize={16} />
      ))}
      {bottomLabels.map((label) => (
        <SvgMathLabel key={`bottom-${label.index}`} x={pointX(label.index)} y={axisY + 24} math={label.math} fontSize={15} />
      ))}
    </svg>
  );
}
